import MainLayout from '@/layouts/MainLayout.vue';

const externalRouters = {
    path: '/',
    component: MainLayout,
    children: [
        {
            path: '/404',
            name: 'Error404Page',
            // lazy load
            component: () => import('../pages/Error404Page.vue'),
            meta: {
                isCustomLang: true,
            },
        },
        {
            path: '/500',
            name: 'Error500Page',
            // lazy load
            component: () => import('../pages/Error500Page.vue'),
            meta: {
                isCustomLang: true,
            },
        },
        { path: '*', redirect: '/404', hidden: true }
    ],

};

export const errorRouters = [externalRouters];
